import sbs from './sbs'

export default [sbs]



// WEBPACK FOOTER //
// ./src/router/domain/index.js